"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/RightSide/Header/RightSideHeaderHeading.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);







const RightSideHeaderHeading = ({
  className,
  title,
  subtitle,
  titleBadge,
  ...props
}) => {
  const rootClassName = _classBuilder2.default.call(void 0, "right-side-header--heading", className)

  return (
    _react2.default.createElement('div', { className: rootClassName, ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}
      ,  title && (titleBadge
        // With a badge, only the name truncates, so the badge stays visible.
        ? (
            _react2.default.createElement('div', { className: "right-side-header--heading--title right-side-header--heading--title--with-badge" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
              , _react2.default.createElement('span', { className: "right-side-header--heading--title-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}},  title )
              ,  titleBadge 
            )
          )
        : _react2.default.createElement('div', { className: "right-side-header--heading--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}},  title )
      )
      ,  subtitle &&
        _react2.default.createElement('div', { className: "right-side-header--heading--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
          ,  subtitle 
        )
    )
  )
}

exports. default = RightSideHeaderHeading
